import HrLayout from "../HrLayout"
import HRDashBoard from "../../ui/HRDashboard";

export default function HrDashBoard() {
    return (
        <HrLayout>
            <HRDashBoard />
        </HrLayout>
    )
}
